import { Container } from '../../components/Container'
import { Section } from '../../components/Section'
import { FAQAdminList } from '../../containers/faq/FAQAdminList'
import { faqs } from '../../data/faq'

export const FAQAdmin = () => {
  return (
    <Section>
      <Container>
        <FAQAdminList items={faqs} />
      </Container>
    </Section>
  )
}
